
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50.5 50.499"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M.25 2.424A2.175 2.175 0 012.424.25h45.652a2.175 2.175 0 012.174 2.174v45.652a2.174 2.174 0 01-2.174 2.173H2.424A2.174 2.174 0 01.25 48.076z","stroke":"#000"}}),_c('path',{attrs:{"d":"M6.642 8.12h13.7M6.642 16.815h13.7M6.642 25.511h13.7M6.642 34.207h38.735M6.642 42.902h38.735","stroke":"currentColor"}})]),_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M45.044 7.92a.966.966 0 00-.965-.964H26.715a.966.966 0 00-.965.964v17.365a.965.965 0 00.965.964H44.08a.965.965 0 00.965-.964z"}}),_c('path',{attrs:{"d":"M42.638 22.39l-2.558-6.825a.481.481 0 00-.851-.1l-3.33 5-1.973-2.367a.481.481 0 00-.783.062l-2.54 4.232M32.019 13.704a1.444 1.444 0 10-1.444-1.444 1.445 1.445 0 001.444 1.444zM45.044 22.399H25.75"}})])])
          )
        }
      }
    